import type {
  IntentWithoutResponseProps,
  IntentWithResponseProps,
} from '../slots/Intent/Intent.js';

export const isIntentWithResponse = (
  props: IntentWithResponseProps | IntentWithoutResponseProps,
): props is IntentWithResponseProps => {
  if ('onResponse' in props) {
    return typeof props.onResponse === 'function';
  }
  return false;
};
